/* eslint-disable react/jsx-fragments */
import { InboxOutlined } from "@ant-design/icons";
import type { GetProp, UploadProps } from "antd";
import { Button, Checkbox, Flex, Upload, message, Typography, Input, Tooltip, Table, InputNumber } from "antd";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import React, { FC, useEffect, useState } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import { ConfirmButtons, CustomSelect, Loader, Modal } from "src/components/ui";
import { UploadingFormModal } from "./ui/UploadingFormModal";
import { AddMembersManuallyModal } from "../../../../../../../../team-members/ui/AddMembersManually";
import syncingdata from "../../../../../../../../../../shared/images/syncingdata.svg";
import { SvgIcon } from "src/shared/icons";
import { useDispatch, useSelector } from "react-redux";
import { uploadLeadFileAndColumnInd } from "src/store/outreach-campaigns/asyncRequests";
import { fullUserSelector, teamSelector, userSelector } from "src/store/user";
import { hubspotGetInformation, getIntegrationLeadsHubspot } from "src/store/user/asyncRequests";
import { useNavigate } from "react-router";

const { Dragger } = Upload;

type ExtractionFileModalProps = {
  open: boolean;
  onCancel: VoidFunction;
  setProspectAmountExtracting: (any) => void;
  addExtLeads;
  fullClose;
};

interface CsvData {
  title: string;
  info: string[];
}

const filtOptions = [
  {
    value: "remove_prev_upload",
    label: "Remove previously uploaded prospects",
  },
  {
    value: "remove_prev_contacted",
    label: "Remove prospects already contacted",
  },
];

export const UploadProspectsHubspotModal: FC<ExtractionFileModalProps> = ({ open, onCancel, setProspectAmountExtracting, addExtLeads, fullClose }) => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState(["lead"]);
  const [availStatus, setAvailStatus] = useState([]);
  const handleFilterChange = (selected) => {
    // console.log(selected, "selected");
    setFilters(selected);
  };
  const {
    integrationListTeamHas,
    fetchingExtLeadsLoading,
    hubspotTotalCnt,
    teamLeadsHaveHubspot: dbTeamLeadsHave,
    fetchingHubspotLeadsDataLoading,
  } = useSelector(fullUserSelector);

  const [teamLeadsHave, setTeamLeadsHave] = useState([]);

  const { id: cliId, email, custom_team_mem_viewing_ids } = useSelector(userSelector);
  const hasHubspotInt = integrationListTeamHas?.find((int) => int?.integration_name === "hubspot");

  useEffect(() => {
    let idOfCli;
    console.log(dbTeamLeadsHave, "dbTeamLeadsHave");
    if (hasHubspotInt?.mapped_users?.length) {
      hasHubspotInt.mapped_users.forEach((mp) => {
        if (mp.mtz_client_id === cliId) {
          idOfCli = mp.ext_id;
        }
      });
    }

    const sorted = [...(dbTeamLeadsHave || [])].sort((a, b) => {
      if (a?.ext_id === "unassigned") return -1;
      if (b?.ext_id === "unassigned") return 1;
      if (a?.ext_id === idOfCli) return -1;
      if (b?.ext_id === idOfCli) return 1;
      return (b?.total || 0) - (a?.total || 0);
    });

    setTeamLeadsHave(sorted);
  }, [dbTeamLeadsHave, hasHubspotInt]);

  const { teamProsCnt, contacts_team_can_have, clientWithTeam } = useSelector(teamSelector);
  const { pageInfo } = clientWithTeam;
  // console.log(teamLeadsHave, "teamLeadsHave");
  useEffect(() => {
    const hubspotStages = integrationListTeamHas?.find((int) => int?.integration_name === "hubspot")?.contact_stages;
    // console.log(
    //   integrationListTeamHas?.find((int) => int?.integration_name === "hubspot"),
    //   "hubspotStageshubspotStages"
    // );
    // console.log(hubspotStages, "availStatus");
    // const idOfCold = hubspotStages?.find((ap) => ap?.label === "Lead")?.id;
    // if (idOfCold) {
    // setFilters(["NONE_TOO"]);
    // }
    // }
    console.log(hubspotStages, "hubspotStageshubspotStages");

    setAvailStatus([{ value: "NONE_TOO", label: "No status" }, ...(hubspotStages?.map((ap) => ({ value: ap?.value, label: ap?.label })) || [])]);
  }, [integrationListTeamHas]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!!open) {
      console.log(filters, "hubspotStageshubspotStages2      ");
      dispatch(getIntegrationLeadsHubspot({ contact_stage_ids: filters }));
    }
  }, [open, filters]);

  const [cntAmntLeftToAdd, setCntAmntLeftToAdd] = useState(0);
  const [inputVal, setInputVal] = useState("");
  const [minMax, setMinMax] = useState(Math.min(cntAmntLeftToAdd, typeof hubspotTotalCnt === "number" ? hubspotTotalCnt : 0));

  useEffect(() => {
    const newMinMax = Math.min(cntAmntLeftToAdd, typeof hubspotTotalCnt === "number" ? hubspotTotalCnt : 0);
    setMinMax(newMinMax);
    if (parseInt(inputVal || "0") > newMinMax) {
      setInputVal(newMinMax.toString());
    }
    setInputVal(newMinMax);
  }, [cntAmntLeftToAdd, hubspotTotalCnt]);

  const [viewOptions, setViewOptions] = useState([{ value: cliId, label: `Me: (${email})` }]);
  const [viewSelections, setViewSelections] = useState({});
  useEffect(() => {
    if (hasHubspotInt?.mapped_users?.length) {
      const initial = {};
      hasHubspotInt.mapped_users.forEach((mp) => {
        let digitsOnly = 0;
        if (mp.mtz_client_id === cliId) {
          digitsOnly = +[...(dbTeamLeadsHave || [])].find((db) => db?.ext_id === mp?.ext_id)?.total || 0;
        }
        if (mp?.ext_id) {
          initial[mp.ext_id] = { assignTo: mp.mtz_client_id !== "notconnected" ? mp.mtz_client_id : "unassigned", digitsOnly }; // default selection is their own ID
        }
      });
      console.log(initial, "initial123");
      setViewSelections(initial);
    }
  }, [hasHubspotInt, dbTeamLeadsHave]);
  const handleSelectedViewChange = (assignTo, userId) => {
    setViewSelections((prev) => ({ ...prev, [userId]: { ...(viewSelections?.[userId] || {}), assignTo } }));
  };
  useEffect(() => {
    const options = [
      { value: "unassigned", label: "Don't assign" },
      { value: cliId, label: `Me (${email})` },
    ];

    const teamCanLookAt = [...(pageInfo?.data?.team_members?.filter((tm) => tm?.id !== cliId) || [])];
    const teamMembers = teamCanLookAt?.map((tm) => {
      return {
        label: `${tm?.first_name?.charAt(0)?.toUpperCase() + tm?.first_name?.slice(1).toLowerCase()} ${
          tm?.last_name?.charAt(0)?.toUpperCase() + tm?.last_name?.slice(1).toLowerCase()
        } - ${tm?.email}`,
        value: tm?.id,
      };
    });
    options.push(...(teamMembers || []));

    setViewOptions(options);
  }, [custom_team_mem_viewing_ids, pageInfo?.data?.team_members]);

  const [page, setPage] = useState(1);
  const handleChangePage = (pg) => {
    setPage(pg);
  };
  const [extractAmounts, setExtractAmounts] = useState({});
  const columns = [
    {
      title: <b>Hubspot lead owner</b>,
      // className: "emails-contact-name",
      render: (record) => {
        const isUnassigned = record?.ext_id === "unassigned";
        const hubspotUser = hasHubspotInt?.mapped_users?.find((us) => us?.ext_id === record?.ext_id);
        return (
          <div>
            {isUnassigned ? (
              <Tooltip title={`Contacts that were not assigned to any team member in Hubspot`} placement="left">
                Unassigned 🌍
              </Tooltip>
            ) : (
              <Tooltip title={hubspotUser?.ext_email} placement="left">
                {hubspotUser?.ext_first_name || hubspotUser?.ext_email} {hubspotUser?.ext_first_name ? hubspotUser?.ext_last_name || "" : ""}
              </Tooltip>
            )}
          </div>
        );
      },
      align: "left",
      width: "100px",
    },
    {
      title: <b>Leads in Hubspot</b>,
      // className: "emails-contact-name",
      render: (record) => {
        return <div>{record?.total?.toLocaleString()}</div>;
      },
      align: "center",
    },
    {
      title: <b>Amount to extract</b>,
      // className: "emails-contact-name",
      render: (record) => {
        const remaining = cntAmntLeftToAdd;
        const amountOfLeadsInHubspot = +record?.total || 0;
        return (
          <div>
            <InputNumber
              controls={false}
              placeholder="Amount"
              min={0}
              value={viewSelections?.[record.ext_id]?.digitsOnly ?? ""}
              onKeyDown={(e) => {
                const okNav = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                const isDigit = /\d/.test(e.key);

                if (!isDigit && !okNav.includes(e.key)) {
                  e.preventDefault();
                  return;
                }

                const input = e.target.closest("div")?.querySelector("input");
                const { selectionStart, selectionEnd } = input || {};
                const before = (input?.value || "").slice(0, selectionStart);
                const after = (input?.value || "").slice(selectionEnd);
                const prospective = okNav.includes(e.key) ? (e.key === "Backspace" ? before.slice(0, -1) + after : before + after) : before + e.key + after;

                const othersSum = Object.entries(viewSelections)
                  .filter(([k]) => k !== record.ext_id)
                  .reduce((a, [, v]) => a + v?.digitsOnly, 0);
                console.log(othersSum, "othersSum", viewSelections);
                const newTotal = othersSum + +(prospective || 0);

                if (remaining <= 0) {
                  e.preventDefault();
                  message.destroy();
                  message.error(`No prospects left. Delete old leads to free up more space, or reach out to support for a larger package.`);
                }
                if (newTotal > remaining) {
                  e.preventDefault();
                  message.destroy();
                  message.error(`Total cannot exceed ${remaining.toLocaleString()}`);
                }

                if (+(prospective || 0) > amountOfLeadsInHubspot) {
                  e.preventDefault();
                  message.destroy();
                  message.error(`Has ${amountOfLeadsInHubspot ?? "no"} prospects in Hubspot`);
                }
                if (newTotal > 10000) {
                  e.preventDefault();
                  message.destroy();
                  message.error(`Can't exceed 10,000 prospects in one upload. Upload 10,000 now and then reupload more after it's completed.`);
                }
              }}
              onChange={(num) => {
                const digitsOnly = +num;
                // const draftTotal = Object.values({ ...viewSelections, [record.ext_id]: +digitsOnly }).reduce((a, b) => a + b, 0);
                console.log("digitsOnly", digitsOnly);
                // if (draftTotal <= remaining)
                setViewSelections({ ...viewSelections, [record.ext_id]: { ...(viewSelections?.[record.ext_id] || {}), digitsOnly } });
              }}
              style={{ width: 110 }}
              pattern="[0-9]*"
            />
          </div>
        );
      },
      align: "center",
    },
    {
      title: <b>Assign to</b>,
      // className: "emails-contact-name",
      render: (record) => {
        return (
          <div>
            <CustomSelect
              className="view-select"
              options={viewOptions}
              value={viewSelections?.[record.ext_id]?.assignTo || "unassigned"}
              onChange={(val) => handleSelectedViewChange(val, record.ext_id)}
              style={{ width: "220px" }}
            />
          </div>
        );
      },
      align: "center",
    },
  ];

  const [checkedFilters, setCheckedFilters] = useState(["remove_prev_upload", "remove_prev_contacted"]);

  // const [options, setOptions] = useState(initialOptions);
  const [prospectAmount, setProspectAmount] = useState(0);
  const [stepNumber, setStepNumber] = useState(1);
  const [openUploadFormModal, setOpenUploadFormModal] = useState(false);
  const [prospectNameValue, setProspectNameValue] = useState("");
  const [isAddMembersManuallyModalOpened, setIsAddMembersManuallyModalOpened] = useState(false);
  const [openUploadModDetails, setOpenUploadModDetails] = useState(false);
  const [upload_name, setupload_name] = useState("");
  const handleInputChange = (e) => {
    setupload_name(e.target.value);
  };
  useEffect(() => {
    let totalCnt = 0;
    teamProsCnt?.forEach((tm) => (totalCnt += +tm?.leadCount || 0));
    const amntLeft = (+contacts_team_can_have || 5000) - totalCnt;
    setCntAmntLeftToAdd(amntLeft > 0 ? amntLeft : 0);
    console.log(contacts_team_can_have, "contacts_team_can_have", totalCnt);
  }, [teamProsCnt, contacts_team_can_have]);

  const closeUploadFormModal = () => {
    setOpenUploadFormModal(false);
  };

  const closeModal = () => {
    onCancel();
    setStepNumber(1);
  };

  const closeAddMembersManuallyModal = () => {
    setIsAddMembersManuallyModalOpened(false);
  };

  const handleSubmit = () => {
    if (stepNumber === 1) {
      dispatch(hubspotGetInformation({ contact_stage_ids: filters }));
      setStepNumber(2);
    } else {
      // setProspectAmountExtracting(cntAmntLeftToAdd);
      // const cleanedRows = [];
      // fileData.forEach((lead) => {
      //   const leadInfo = { upload_name: prospectNameValue };
      //   options.forEach((o) => {
      //     if (o.value && lead?.length > o.column) {
      //       leadInfo[o.value] = lead[o.column];
      //     }
      //   });
      //   cleanedRows.push(leadInfo);
      // });
      message.info("Adding prospects");

      const removeContactedPros = checkedFilters?.includes("remove_prev_contacted");
      const removeLeadsAlreadyUpl = checkedFilters?.includes("remove_prev_upload");
      // console.log(viewSelections, "viewSelections");
      // dispatch(uploadLeadFileAndColumnInd({ cleanedRows, options, removeContactedPros, removeLeadsAlreadyUpl, totalLeads: prospectAmount }));
      dispatch(
        uploadLeadFileAndColumnInd({
          external: "hubspot",
          extractInfo: { extractions: viewSelections, contact_stage_ids: filters, upload_name },
          removeContactedPros,
          removeLeadsAlreadyUpl,
        })
      );
      setupload_name("");
      setStepNumber(1);
      fullClose();

      // onCancel();
    }
  };

  const onChange: GetProp<typeof Checkbox.Group, "onChange"> = (checkedValues) => {
    setCheckedFilters(checkedValues);
  };
  const openDets = () => {
    setOpenUploadModDetails(true);
  };
  console.log(stepNumber, "stepNumberstepNumber");
  return (
    <>
      {isAddMembersManuallyModalOpened && <AddMembersManuallyModal isAddContact onClose={closeAddMembersManuallyModal} />}
      <Modal
        width={500}
        open={openUploadModDetails}
        title={"Amount of prospects in your account"}
        onCancel={() => setOpenUploadModDetails(false)}
        zIndex={2000}
      >
        <Typography.Paragraph style={{ fontSize: "13px" }}>
          Assign, edit, or delete prospects you have in the CRM - "Contacts" tab. If you need more reach out to your Meetz customer success point of contact.
        </Typography.Paragraph>
        <br />
        <b>Total amount of prospects team can upload:</b>
        <br />
        {+contacts_team_can_have || 5000} prospects
        <br />
        <br />
        <b>Prospects already uploaded in your team:</b>
        <br />
        <i> Total unassigned prospects:</i> {(+teamProsCnt?.find((tm) => tm?.clientId === "unassigned")?.leadCount || 0)?.toLocaleString()}
        <br />
        {teamProsCnt?.map((team) => {
          if (team?.clientId === "unassigned") {
            return "";
          }
          const tm = pageInfo?.data?.team_members?.find((tm) => tm?.id === team?.clientId);
          if (!tm) {
            return "";
          }
          const name = `${tm?.first_name?.charAt(0)?.toUpperCase() + tm?.first_name?.slice(1).toLowerCase()} ${
            tm?.last_name?.charAt(0)?.toUpperCase() + tm?.last_name?.slice(1).toLowerCase()
          }`;
          const email = tm?.email;
          return (
            <div key={team?.id} style={{ marginTop: "3px" }}>
              <Tooltip title={`Team members email: ${email}`} placement="top">
                {" "}
                <i> {name}</i>
              </Tooltip>
              : {(+team?.leadCount || 0)?.toLocaleString()}
            </div>
          );
        })}
      </Modal>
      <Modal
        width={750}
        open={open}
        title={"Upload leads from Hubspot"}
        onCancel={() => {
          if (stepNumber === 2) {
            setStepNumber(1);
          } else {
            closeModal();
          }
        }}
        zIndex={900}
      >
        <Flex vertical>
          {/* {stepNumber ===     0 ? ( */}
          {stepNumber === 1 ? (
            <>
              {" "}
              <Flex align="center">
                {" "}
                Hubspot contact "lifecycle stage":
                <Tooltip
                  title={`"Lead" is the default stage for newly extracted prospects in Hubspot. If you're not sure which stage to select use this one.`}
                  placement="top"
                >
                  <SvgIcon type={"tooltip"} style={{ marginLeft: "5px" }} />
                </Tooltip>
                <CustomSelect
                  disabled={fetchingExtLeadsLoading}
                  value={filters}
                  // className={"phone-select"}
                  mode="multiple"
                  // multi
                  options={availStatus}
                  onChange={handleFilterChange}
                  popupClassName={"phone-select-dropdown"}
                  style={{ width: "300px", marginLeft: "15px" }}
                />
              </Flex>
              <br />
              <Flex align="center">
                <b> Amount of leads in Hubspot:</b>{" "}
                {fetchingExtLeadsLoading ? (
                  <Flex align="center" style={{ marginLeft: "30px" }}>
                    <Loader />
                    <div style={{ marginLeft: "20px" }}> Checking amount...</div>
                  </Flex>
                ) : (
                  <div style={{ marginLeft: "5px" }}>
                    {" "}
                    {typeof hubspotTotalCnt === "number" ? (
                      hubspotTotalCnt.toLocaleString()
                    ) : (
                      <div style={{ fontSize: "12px", width: "80%" }}>
                        *Error in getting your leads check your internet or reconnect Hubspot integration. Also make sure you have a paid subscription in
                        Hubspot (It's a requirement).
                        <br />
                        <br />
                        <Button className="link" onClick={() => navigate("/settings?int=hubspot")}>
                          Reconnect
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </Flex>
              {/* <br />
              <Flex align="center">
                {" "}
                2. Amount of leads to get from Hubspot:{" "}
                <Input
                  // type="number"
                  value={inputVal}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                      const num = parseInt(val || "0");
                      if (num <= minMax) setInputVal(val);
                    }
                  }}
                  max={minMax}
                  popupClassName={"phone-select-dropdown"}
                  style={{ width: "120px", marginLeft: "15px" }}
                />
              </Flex> */}
              <Typography.Paragraph className={"hint"} style={{ marginTop: "20px" }}>
                <b>Prospect Uploads: </b>
                {cntAmntLeftToAdd} left to upload -{" "}
                <Button className="link" onClick={openDets}>
                  Details
                </Button>
              </Typography.Paragraph>
              <br />
              <br />
            </>
          ) : (
            <>
              {fetchingHubspotLeadsDataLoading ? (
                <div style={{ width: "100%" }}>
                  <div style={{ marginLeft: "60px", marginTop: "30px", marginBottom: "30px", width: "fit-content" }}>
                    {" "}
                    <img src={syncingdata} alt={"Empty table"} className={"table-empty-img"} width={140} style={{ marginLeft: "50px" }} />
                    <br />
                    <Flex justify="center" align="center" style={{ marginTop: "20px" }}>
                      <Loader />
                      <div style={{ marginLeft: "20px", width: "fit-content" }}>Syncing with your Hubspot account</div>
                    </Flex>
                  </div>
                </div>
              ) : (
                <>
                  <Table
                    // key={key}
                    customClassName={"emails-table"}
                    loading={false}
                    columns={columns}
                    dataSource={teamLeadsHave?.length && page ? teamLeadsHave?.slice((page - 1) * 10, page * 10) : []}
                    style={{ width: "100%", marginLeft: "-5px" }}
                    pageSize={10}
                    totalAmnt={teamLeadsHave?.length || 0}
                    // rowSelection={{ ...rowSelection }} For now one by one.
                    currentPage={page}
                    setCurrentPage={handleChangePage}
                    totalPages={teamLeadsHave?.length > 9 ? Math.ceil(teamLeadsHave?.length / 10) || 1 : 1}
                    quickDropdownSkip
                    quickSkip
                  />
                </>
              )}
              <Flex align="center" style={{ marginTop: "20px" }}>
                <Typography.Paragraph>
                  <b>Upload Name:</b>
                </Typography.Paragraph>
                <Input placeholder={"Upload name"} style={{ marginLeft: "15px", width: "200px" }} value={upload_name} onChange={handleInputChange} />
              </Flex>
              <Typography.Paragraph className={"hint"} style={{ marginTop: "10px" }}>
                <b>Amount to upload from Hubspot: </b>
                {Object.entries(viewSelections || {}).reduce((a, [, v]) => a + v?.digitsOnly, 0)} prospects
              </Typography.Paragraph>
              <Typography.Paragraph className={"hint"} style={{ marginTop: "10px" }}>
                <b>Prospect Uploads: </b>
                {cntAmntLeftToAdd} left -{" "}
                <Button className="link" onClick={openDets}>
                  Details
                </Button>
              </Typography.Paragraph>{" "}
              <Typography.Paragraph className={"hint"} style={{ marginTop: "20px", width: "60%" }}>
                Meetz ensures your uploaded leads don't have duplicates and updates their status.{" "}
                <Tooltip
                  placement={"top"}
                  title={
                    <>
                      <b>Note: </b>
                      <br />
                      When you upload these prospects they will be marked as the "Lifecycle stage" of <b>"Approaching"</b> in your Hubspot account in order to
                      ensure organization. If you add the "Lifecycle stage" of <b>"Meetz"</b> to your Hubspot account before uploading here so it will default
                      to that stage instead.
                      <br />
                      <br />
                      We do the above to ensure you don't accidently reach out to them twice.
                    </>
                  }
                >
                  <SvgIcon type={"tooltip"} style={{ marginLeft: 3, verticalAlign: "middle", height: "20px", cursor: "pointer" }} />
                </Tooltip>
              </Typography.Paragraph>
              <Typography.Title level={4} style={{ marginTop: 28, marginBottom: 8 }}>
                Filters:
              </Typography.Title>
              <Checkbox.Group style={{ width: "100%", margin: "5px 0 28px 0" }} onChange={onChange} value={checkedFilters}>
                <Flex vertical gap={10}>
                  {filtOptions.map((item) => (
                    <Checkbox key={item.value} value={item.value}>
                      {item.label}
                    </Checkbox>
                  ))}
                </Flex>
              </Checkbox.Group>
            </>
          )}
          <ConfirmButtons
            onCancel={() => (stepNumber === 1 ? closeModal() : setStepNumber(1))}
            leftButtonTitle={"Back"}
            rightButtonTitle={stepNumber === 1 ? "Next step" : "Upload prospects"}
            disabled={
              !!fetchingExtLeadsLoading ||
              +inputVal <= 0 ||
              (stepNumber === 2 && (!upload_name?.trim()?.length || !Object.entries(viewSelections || {}).reduce((a, [, v]) => a + v?.digitsOnly, 0)))
            }
            handleSubmit={handleSubmit}
            // disabledExplanation={
            //   !cntAmntLeftToAdd ? `No prospects left to upload` : !prospectAmount ? "Add prospects - Make sure to mark the email column" : "Add file name"
            // }
          />{" "}
          <Typography.Paragraph className={"secondary-label-subtitle"} style={{ marginTop: 8 }}>
            *By Uploading You Agree to the T&C Policies.
          </Typography.Paragraph>
        </Flex>
      </Modal>
    </>
  );
};
